import React from "react";
import Office1 from '../images/ComponentImg/office1.jpg';
import Office2 from '../images/ComponentImg/office2.jpg';
import Office3 from '../images/ComponentImg/office3.jpg';
import Office4 from '../images/ComponentImg/office4.jpg';
import Office5 from '../images/ComponentImg/office5.jpg';
import Office6 from '../images/ComponentImg/office6.jpg';

export function HlzOffice() {
  return (
    <div className='container py-5'>
      {/* <h2 className='text-center fs-1 mb-5 fw-bold'>Office Area</h2> */}
      <h2 className='text-center fs-1 mb-5'>Office Area</h2>
      <div className='row'>
        <div className='col-md-4 px-2'>
          <div className='my-3'> <img src={Office1} className='img-fluid' alt="" /> </div>
          <div className='my-3'> <img src={Office2} className='img-fluid' alt="" /> </div>
        </div>
        <div className='col-md-4 px-2'>
          <div className='my-3'> <img src={Office3} className='img-fluid' alt="" /> </div>
          <div className='my-3'> <img src={Office4} className='img-fluid' alt="" /> </div>
        </div>
        <div className='col-md-4 px-2'>
          <div className='my-3'> <img src={Office5} className='img-fluid' alt="" /> </div>
          <div className='my-3'> <img src={Office6} className='img-fluid' alt="" /> </div>
        </div>
      </div>
    </div>
  )
}